/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import SINI_POLYGON_CONFIG from "./SINI_POLYGON_CONFIG";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import { set_value_sini } from "../../App/actions/sini_v2";

/*PICTURE*/
import ICON_BACK from "../../Assets/jsx/ICON_BACK";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import colors_flood from "../../Data/colors_flood.json";

/*CONST*/

class SINI_DISASTER_RISK_FULL extends Component {
  state = {
    anchor: null,
    modal_layer_config: false,
    modal_download: false,
    download_item: "",
  };

  toggle_download = (e) => {
    const name = e?.target?.name;
    this.setState({ modal_download: !this.state.modal_download });
    if (name) {
      this.setState({
        download_item: name,
      });
    }
    if (e) {
      this.setState({ anchor: e.currentTarget });
    }
  };

  toggle_layer_config = (e) => {
    this.setState({ modal_layer_config: !this.state.modal_layer_config });
    if (e) {
      this.setState({ anchor: e.currentTarget });
    }
  };

  toggle_sini_map_show = (item) => {
    let { sini_map_show } = this.props.sini;
    if (sini_map_show.includes(item)) {
      sini_map_show = sini_map_show.filter((element) => element !== item);
    } else {
      sini_map_show.push(item);
    }
    this.props.set_value_sini({
      key: "sini_map_show",
      value: sini_map_show,
    });
  };

  on_set_sini_menu_active = () => {
    this.props.set_value_sini({
      key: "sini_menu_active",
      value: "",
    });
    this.props.set_value_sini({
      key: "sini_map_show",
      value: ["poi", "isochrone"],
    });
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const { modal_layer_config, anchor } = this.state;

    //global props
    const {
      request_id_active,
      ai_parent_detail_list,
      sini_map_show,
      is_show_download_button,
    } = this.props.sini;
    const { loading_item_array } = this.props.loading_reducer;

    //content
    const is_loading_flood = loading_item_array.includes("flood");
    const is_loading_landslide = loading_item_array.includes("landslide");
    const is_loading_tsunami = loading_item_array.includes("tsunami");
    const sini_object = ai_parent_detail_list.find(
      (item) => item.request_id === request_id_active
    );

    const flood_one = sini_object?.flood_one;
    const landslide_one = sini_object?.landslide_one;
    const tsunami_one = sini_object?.tsunami_one;

    // const flood_neighbor = sini_object?.flood_neighbor;
    const flood_intersect_list = sini_object?.flood_intersect_list || [];
    const landslide_intersect_list = sini_object?.landslide_intersect_list;
    const tsunami_intersect_list = sini_object?.tsunami_intersect_list;

    let landslide_content;
    let tsunami_content;

    let flood_content;

    if (
      is_loading_flood ||
      is_loading_landslide ||
      is_loading_tsunami ||
      flood_one ||
      landslide_one ||
      tsunami_one ||
      flood_intersect_list ||
      landslide_intersect_list ||
      tsunami_intersect_list
    ) {
      if (is_loading_flood) {
        flood_content = (
          <>
            <p className="text_medium sub_color">
              {dict?.["Loading data"]?.[language]}...
            </p>
            <br />
          </>
        );
      } else if (
        flood_one?.properties?.["KELAS_RISIKO"] ||
        flood_intersect_list?.length > 0
      ) {
        flood_content = (
          <main>
            <table>
              <tbody>
                <tr>
                  <td>
                    <button
                      className={
                        sini_map_show.includes("flood_neighbor")
                          ? "checklist_active"
                          : "checklist_not"
                      }
                      onClick={this.toggle_sini_map_show.bind(
                        this,
                        "flood_neighbor"
                      )}
                    />
                  </td>
                  <td>
                    <p className="text_medium sub_color">
                      {dict?.["Flood risk at the clicked point"]?.[language]}
                    </p>
                    <p className="text_bold">
                      {flood_one?.properties?.["KELAS_RISIKO"] ||
                        dict?.["No data"]?.[language]}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <p className="text_medium margin_right sub_color">
                      {dict?.["Data around the point"]?.[language]}
                    </p>
                    <p className="text_bold">
                      {flood_intersect_list?.length || 0} area
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            {is_show_download_button && (
              <button
                className="badge background_grey_light margin_bottom"
                name="flood_one"
                onClick={this.toggle_download}
              >
                {dict?.["Download"]?.[language]}
              </button>
            )}
          </main>
        );
      } else {
        flood_content = (
          <p className="text_medium sub_color">
            {dict?.["No data"]?.[language]}
          </p>
        );
      }

      if (is_loading_landslide) {
        landslide_content = (
          <>
            <p className="text_medium sub_color">
              {dict?.["Loading data"]?.[language]}...
            </p>
            <br />
          </>
        );
      } else if (is_loading_flood) {
        landslide_content = <></>;
      } else if (
        landslide_one?.properties?.["KELAS_RISIKO"] ||
        landslide_intersect_list?.length > 0
      ) {
        landslide_content = (
          <main>
            <table>
              <tbody>
                <tr>
                  <td>
                    <button
                      className={
                        sini_map_show.includes("landslide_neighbor")
                          ? "checklist_active"
                          : "checklist_not"
                      }
                      onClick={this.toggle_sini_map_show.bind(
                        this,
                        "landslide_neighbor"
                      )}
                    />
                  </td>
                  <td>
                    <p className="text_medium sub_color">
                      {
                        dict?.["Landslide risk at the clicked point"]?.[
                          language
                        ]
                      }
                    </p>
                    <p className="text_bold">
                      {landslide_one?.properties?.["KELAS_RISIKO"] ||
                        dict?.["No data"]?.[language]}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <p className="text_medium sub_color margin_right">
                      {dict?.["Data around the point"]?.[language]}
                    </p>
                    <p className="text_bold">
                      {landslide_intersect_list?.length || 0} area
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </main>
        );
      } else {
        landslide_content = (
          <p className="text_medium sub_color">
            {dict?.["No data"]?.[language]}
          </p>
        );
      }

      if (is_loading_tsunami) {
        tsunami_content = (
          <>
            <p className="text_medium sub_color">
              {dict?.["Loading data"]?.[language]}...
            </p>
            <br />
          </>
        );
      } else if (is_loading_landslide) {
        tsunami_content = <></>;
      } else if (
        tsunami_one?.properties?.["KELAS_RISIKO"] ||
        tsunami_intersect_list?.length > 0
      ) {
        tsunami_content = (
          <table>
            <tbody>
              <tr>
                <td>
                  <button
                    className={
                      sini_map_show.includes("tsunami_neighbor")
                        ? "checklist_active"
                        : "checklist_not"
                    }
                    onClick={this.toggle_sini_map_show.bind(
                      this,
                      "tsunami_neighbor"
                    )}
                  />
                  <button />
                </td>
                <td>
                  <p className="text_medium sub_color">
                    {dict?.["Tsunami risk at the clicked point"]?.[language]}
                  </p>
                  <p className="text_bold">
                    {tsunami_one?.properties?.["KELAS_RISIKO"] ||
                      dict?.["No data"]?.[language]}
                  </p>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <p className="text_medium sub_color margin_right">
                    {dict?.["Data around the point"]?.[language]}
                  </p>
                  <p className="text_bold">
                    {tsunami_intersect_list?.length || 0} area
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        );
      } else {
        tsunami_content = (
          <p className="text_medium sub_color">
            {dict?.["No data"]?.[language]}
          </p>
        );
      }
    }

    const legend_content = (
      <main className="container_light outline_grey">
        <p className="text_bold margin_bottom">
          {dict?.["Legend"]?.[language]}
        </p>
        <button
          className="button_small margin_bottom background_black"
          onClick={this.toggle_layer_config}
        >
          {dict?.["Edit info on map"]?.[language]}
        </button>
        <br />
        <table className="text_medium sub_color">
          <tbody>
            {colors_flood.map((item, idx) => {
              return (
                <tr key={idx}>
                  <td>
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "5px",
                        backgroundColor: item.color,
                      }}
                    />
                  </td>
                  <td>{item.name}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </main>
    );

    const modal_layer_config_content = (
      <FLOAT_MENU
        id="basic-menu"
        anchorEl={anchor}
        open={modal_layer_config}
        onClose={this.toggle_layer_config}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <div
          style={{
            width: "250px",
          }}
        >
          <SINI_POLYGON_CONFIG />
        </div>
      </FLOAT_MENU>
    );

    return (
      <main className="sini_full_parent">
        {modal_layer_config_content}
        <section className="sini_full_header">
          <table>
            <tbody>
              <tr>
                <td
                  style={{ width: "30px" }}
                  onClick={this.on_set_sini_menu_active}
                  data-mapid="clickBack"
                >
                  <ICON_BACK />
                </td>
                <td className="text_left">
                  <div className="badge background_grey_light margin_bottom margin_right">
                    {dict?.["Disaster"]?.[language]}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section className="sini_full_scroll_area">
          <section className="container_light margin_bottom outline_grey">
            <p className="text_medium sub_color">
              {dict?.["Flood"]?.[language]}
            </p>
            {flood_content}
          </section>
          <section className="container_light margin_bottom outline_grey">
            <p className="text_medium sub_color">
              {dict?.["Landslide"]?.[language]}
            </p>
            {landslide_content}
          </section>
          <section className="container_light margin_bottom outline_grey">
            <p className="text_medium sub_color">
              {dict?.["Tsunami"]?.[language]}
            </p>
            {tsunami_content}
          </section>
          {legend_content}
        </section>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  sini: state.sini,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, { set_value_sini })(
  SINI_DISASTER_RISK_FULL
);
